export default __webpack_public_path__ + "static/media/auto.0e0e5c1d.jpg";